import { useState } from 'react';
import { grey, green } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DownloadIcon from '@mui/icons-material/Download';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Fab from '@mui/material/Fab';

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  padding: '6px 12px',
  backgroundColor: 'white',
  borderWidth: 3,
  borderRadius: 10,
  borderColor: theme.palette.primary.main,
  fontWeight: 'bold',
  minWidth: 200,
  '&:hover': {
    backgroundColor: 'white',
    borderWidth: 3,
    borderColor: 'rgba(35, 200, 167, 0.5)',
  },
}));

export default ColorButton;

export const ColorLoadingButton = styled(LoadingButton)<ButtonProps>(({ theme }) => ({
  padding: '6px 12px',
  backgroundColor: 'white',
  borderWidth: 3,
  borderRadius: 10,
  borderColor: theme.palette.primary.main,
  fontWeight: 'bold',
  minWidth: 200,
  '&:hover': {
    backgroundColor: 'white',
    borderWidth: 3,
    borderColor: 'rgba(35, 200, 167, 0.5)',
  },
}));

export const RoundButton = ({ onClick }: { onClick: () => void }) => {
  const buttonSx = {
    bgcolor: '#a1a1a1',
    '&:hover': {
      bgcolor: grey[700],
    },
  };

  return (
    <Box sx={{ m: 1, position: 'relative' }}>
      <Fab aria-label="save" color="primary" sx={buttonSx} onClick={onClick}>
        <KeyboardArrowUpIcon fontSize="large" />
      </Fab>
    </Box>
  );
};

export const LoadingRoundButton = ({ onClick }: { onClick: () => Promise<void> }) => {
  const [loading, setLoading] = useState(false);

  const buttonSx = {
    ...(loading && {
      bgcolor: green[500],
      '&:hover': {
        bgcolor: green[700],
      },
    }),
  };

  const handleClick = async () => {
    if (!loading) {
      setLoading(true);
      try {
        await onClick();
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    }
  };

  return (
    <Box sx={{ m: 1, position: 'relative' }}>
      <Fab aria-label="save" color="secondary" sx={buttonSx} onClick={handleClick}>
        <DownloadIcon fontSize="large" />
      </Fab>
      {loading && (
        <CircularProgress
          size={68}
          sx={{
            color: green[500],
            position: 'absolute',
            top: -6,
            left: -6,
            zIndex: 1,
          }}
        />
      )}
    </Box>
  );
};
